import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#644BB1" }}>Problem</span>
            </h2>
            <p>
              The purpose of this app was to provide the models, photographers,
              makeup artists and other talents and recruiters the same services
              they enjoy on the website while working remotely or traveling.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/qroll/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1277}
              height={773}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
